import Vue from 'vue'
import Desk from './desk.vue'
import "@/js/rem";

Vue.config.productionTip = false

new Vue({
  el: '#app',
  components: { Desk },
  template: '<Desk/>'
})



// WEBPACK FOOTER //
// ./src/pages/dict/desk/desk.js